import { Outlet } from 'react-router-dom';

import Header from '../Header/Header';

const Container = () => {
  return (
    <div className="sup-container">
      <Header />
      <Outlet />
    </div>
  );
};

export default Container;
